"use strict";
/* @ngInject */
function preferenceService(API_URL, $http, $q, userService) {
    return {
        getInstitutionPreference: function (tenantId) {
            return $http.get("" + API_URL.preference.replace(/:tenantId/, tenantId))
                .then(function (response) { return response.data; })
                .catch(function (errorResponse) {
                if (errorResponse.status === 404) {
                    console.log('Handling 404 and returning...');
                    return {};
                }
                else {
                    console.log('Rejecting with error:', errorResponse);
                    return $q.reject(errorResponse);
                }
            });
        },
        setUserPreference: function (preference) {
            return userService.get().then(function (currentUser) {
                preference.userId = currentUser.userId;
                return $http.post("" + API_URL.updateUserPreferences, preference)
                    .then(function (response) { return response.status; });
            });
        }
    };
}
exports.preferenceService = preferenceService;



/** WEBPACK FOOTER **
 ** ./app/common/preference/preference.service.ts
 **/